import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { AccountEnrichment } from '../../components/account/account-enrichment/AccountEnrichment';
const AccountEnrichmentContainer = props => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { getProfile } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: profile } = useQuery(getProfile());
    if (!profile || !('email' in profile)) {
        return null;
    }
    return _jsx(AccountEnrichment, Object.assign({}, props, { profile: profile }));
};
export default AccountEnrichmentContainer;
